import { useTranslation } from 'react-i18next';
import { pb } from '../lib/pb';
import { errorMessage } from '../lib/errors';
import { toast, useCurrentMap } from '../store/store';
import { Icon } from '../panels/Icon';

function download(name: string, data: unknown) {
  const blob = new Blob([JSON.stringify(data, null, 2) + '\n'], { type: 'application/json' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
}

export function ExportAdmin() {
  const { t } = useTranslation();
  const map = useCurrentMap();
  if (!map) return null;
  const get = async (profile: 'full' | 'ingame') => {
    try {
      const data = await pb.send(`/api/mapeditor/maps/${map.slug}/export?profile=${profile}`, {});
      download(`${map.slug}.${profile === 'full' ? 'export' : 'ingame'}.json`, data);
    } catch (err) {
      toast(errorMessage(err), 'error');
    }
  };
  return (
    <div className="admin-export">
      <p className="muted small">{t('admin.export.help')}</p>
      <button onClick={() => void get('full')}>
        <Icon id="tool-download" /> {t('admin.export.full')}
      </button>
      <p className="muted small">{t('admin.export.fullHelp')}</p>
      <button onClick={() => void get('ingame')}>
        <Icon id="tool-download" /> {t('admin.export.ingame')}
      </button>
      <p className="muted small">{t('admin.export.ingameHelp')}</p>
      <div className="group-label">{t('admin.export.snapshot')}</div>
      <pre className="mono small">npm --prefix web run snapshot -- {map.slug}</pre>
      <p className="muted small">{t('admin.export.snapshotHelp')}</p>
    </div>
  );
}
